export const MARKETING_CARD_IMAGE_ADDRESS =
  "b3bbe7e6-f68e-45e3-8124-691e18a4a3ca";
export const MARKETING_BANNER_IMAGE_ADDRESS =
  "fb06f1b7-87ff-4fcf-8a98-51a7fb4ba36d";
export const LARGE_MARKETING_IMAGE_ADDRESS =
  "0f40a0e7-fa9a-44d9-8391-4d4efecfc292";
export const LARGE_MARKETING_BANNER_IMAGE_ADDRESS =
  "5c013589-65c1-4d45-9059-d4a314fe9b03";
